export const INITIAL_FORM = {
  contact_name: "",
  contact_email: "",
  contact_phone: "",
  business_name: "",
  website_url: "",
  industry: "",
  business_description: "",
  target_audience: "",
  revenue_range: "",
  marketing_budget: "",
  competitors: "",
  keywords: "",
  current_channels: [],
  business_goals: "",
  biggest_challenges: "",
  existing_tools: "",
  social_media_profiles: "",
  google_search_console: "",
  google_analytics: "",
  google_ads: "",
  meta_ads: "",
  tiktok_ads: "",
  google_my_business: "",
  website_platform: "",
  new_website_plans: "",
  crm_system: "",
  social_media_management: "",
  content_creation: "",
  referral_source: "",
  additional_info: "",
};

export const canProceedFromStep = (step, formData) => {
  switch (step) {
    case 1:
      return !!(formData.contact_name && formData.contact_email && formData.business_name && formData.industry && formData.business_description && formData.revenue_range);
    case 2:
      return !!(formData.competitors && formData.keywords && formData.business_goals && formData.biggest_challenges);
    case 3:
      return !!(formData.google_search_console && formData.google_analytics && formData.google_ads && formData.meta_ads && formData.tiktok_ads && formData.google_my_business);
    case 4:
      return !!(formData.website_platform && formData.crm_system && formData.social_media_management && formData.content_creation && formData.referral_source);
    default:
      return true;
  }
};
